import {forwardRef,type AnchorHTMLAttributes} from 'react';
type Props=Omit<AnchorHTMLAttributes<HTMLAnchorElement>,'href'> & {href:string|{pathname?:string;query?:Record<string,string>};prefetch?:boolean;replace?:boolean;scroll?:boolean;locale?:string};
export default forwardRef<HTMLAnchorElement,Props>(function Link({href,prefetch:_prefetch,replace:_replace,scroll:_scroll,locale:_locale,...props},ref){
  const value=typeof href==='string'?href:(href.pathname??'')+(href.query?'?'+new URLSearchParams(href.query):'');
  return <a {...props} href={value} ref={ref}/>;
});
